/** @jsxImportSource @emotion/react */
import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as snackbarActions from "../../../../actions/snackbarActions";
import PageTitle from "../../../Utils/smsTitle";
import { SubHeader } from "../../../../Containers/SubHeader";
import MainSnackbar from "../../../Utils/Snackbar/SmsSnackbar";
import ObGynSidebar from "../../Utils/ObGynSidebar";
import ObGynPatientInfo from "../../Utils/ObGynPatientInfo";
import { useFamilyPlanning } from "./hooks/useFamilyPlanning";
import { FamilyPlanningForm } from "./FamilyPlanningForm";
import { FPHistoryTimeline } from "./FPHistoryTimeline";
import { FPMethodEligibility } from "./FPMethodEligibility";
import {
    FPPageWrapper, FPHeader, FPHeaderLeft, FPHeaderTitle, FPHeaderSub,
    FPHeaderStats, FPStatChip,

    FPLoading,
} from "./FamilyPlanningStyles";
import { ObGynTabBar, ObGynTabBtn, ObGynTabBadge } from "../../Utils/ObGynTabStyles";

/* ═══════════════════════════════════════════════════════════════
   FamilyPlanningPage — Main page for Task 17: Family Planning
   Tabs: FP Service | FP History | Method Guide
   Route: /gyn-and-obs-family-planning/:patient_number/:visit_id/:patient_type
   ═══════════════════════════════════════════════════════════════ */

const FamilyPlanningPage = function (props) {
    const actions = props.actions;
    const snackbar = props.snackbar;
    const params = props.match.params;
    const patient_number = params.patient_number;
    const visit_id = params.visit_id;
    const patient_type = params.patient_type;

    /* ── Hook ── */
    const fp = useFamilyPlanning(actions, patient_number, visit_id);

    const closeSnackbar = function () { actions.snackbarActions.hideSnackbar(); };

    /* ── Loading ── */
    if (fp.loading) {
        return (
            <div>
                <PageTitle title="Family Planning" />
                <SubHeader title="OB/GYN" subTitle="Family Planning" />
                <MainSnackbar variant={snackbar.variant} message={snackbar.message}
                    open={snackbar.open} handleCloseBar={closeSnackbar} />
                <ObGynSidebar patient_number={patient_number} visit_id={visit_id} patient_type={patient_type}>
                    <ObGynPatientInfo patient_number={patient_number} visit_id={visit_id} patient_type={patient_type} />
                    <FPPageWrapper>
                        <FPLoading>⏳ Loading family planning data...</FPLoading>
                    </FPPageWrapper>
                </ObGynSidebar>
            </div>
        );
    }

    return (
        <div>
            <PageTitle title="Family Planning" />
            <SubHeader title="OB/GYN" subTitle="Family Planning" />
            <MainSnackbar variant={snackbar.variant} message={snackbar.message}
                open={snackbar.open} handleCloseBar={closeSnackbar} />
            <ObGynSidebar patient_number={patient_number} visit_id={visit_id} patient_type={patient_type}>
                <ObGynPatientInfo patient_number={patient_number} visit_id={visit_id} patient_type={patient_type} />
                <FPPageWrapper>

                    {/* ─── Tab Bar ─── */}
                    <ObGynTabBar>
                        <ObGynTabBtn
                            active={fp.activeTab === "service"}
                            onClick={function () { fp.setActiveTab("service"); }}
                        >
                             FP Service
                        </ObGynTabBtn>
                        <ObGynTabBtn
                            active={fp.activeTab === "history"}
                            onClick={function () { fp.setActiveTab("history"); }}
                        >
                            FP History
                            <ObGynTabBadge active={fp.activeTab === "history"}>
                                {fp.fpRecords.length}
                            </ObGynTabBadge>
                        </ObGynTabBtn>
                        {/* <ObGynTabBtn
                            active={fp.activeTab === "eligibility"}
                            onClick={function () { fp.setActiveTab("eligibility"); }}
                        >
                            Method Guide
                        </ObGynTabBtn> */}
                    </ObGynTabBar>

                    {/* ─── Tab Content ─── */}
                    {fp.activeTab === "service" && (
                        <FamilyPlanningForm fp={fp} />
                    )}

                    {fp.activeTab === "history" && (
                        <FPHistoryTimeline fp={fp} />
                    )}

                    {fp.activeTab === "eligibility" && (
                        <FPMethodEligibility fp={fp} />
                    )}

                </FPPageWrapper>
            </ObGynSidebar>
        </div>
    );
};

/* ─── Redux Connect ─── */
function mapStateToProps(state) {
    return { snackbar: state.snackbar };
}

function mapDispatchToProps(dispatch) {
    return { actions: { snackbarActions: bindActionCreators(snackbarActions, dispatch) } };
}

export default connect(mapStateToProps, mapDispatchToProps)(FamilyPlanningPage);
